<template>
    <div class="mx-5" >
       <div class="alert mx-auto col-lg-10 my-10 " v-if="statoupdated" align="center">
  <span class="closebtn"  @click.prevent="goBack()">&times;</span>
  stato della segnalazione aggiornato correttamente
</div>
<div class="alert mx-auto col-lg-10 my-10 " style="background-color:red" v-if="invalid" align="center">
  <span class="closebtn"  @click.prevent="goBack()">&times;</span>
  il link non è più valido - aggiornare manualmente lo stato
</div>
      <h5 class="text-center">Elenco segnalazioni</h5>
      <div align="center">
         <h4 v-if="this.segnalazioni.length===0" class="text-center"> - nessuna segnalazione - </h4>
      <ul class="list-group-flush col-lg-10 " align="center">
        <li id="listClick" class="list-group-item px-6"
          v-for="segnalazione in segnalazioni"
          :key="segnalazione.id" >
         <card-segnalazione-completa  :segnalazione="segnalazione" :selected="selected" @sel="seleziona(segnalazione.id)" @overl="overlay=!overlay"/></li>
      </ul>
      </div>
          <overlay-stato :relative="relative"
            :value="overlay" @close="overlay = false" :overlay="overlay" :segnalazioneid="selected " :codcomune="codiceComune"></overlay-stato>
    </div>

</template>

<script>

import SegnalazioniDataService from '@/service/SegnalazioniDataService.js'
import cardSegnalazioneCompleta from './card-segnalazione-completa.vue'
import overlayStato from './overlay-stato.vue'

export default {
  components: {
    cardSegnalazioneCompleta,
    overlayStato
  },
  name: 'segnalazioniComune',
  props: {
    codiceComune: String,
    filtri: Array
  },
  data () {
    return {
      ParamCid: this.$route.params.cid,
      segnalazioni: [],
      principale: [],
      archivio: [],
      selected: null,
      relative: true,
      overlay: false,
      statoupdated: false,
      invalid: false
    }
  },

  methods: {
    caricaSegnalazioni (idc) {
      return SegnalazioniDataService
        .getSegnalazioniByCommuneId(idc)
        .then(response => {
          console.log(response.data)
          return response.data
        })
        .catch(e => {
          console.log(e)
          return []
        })
    },

    seleziona (selectedSegnalazione) {
      if (this.selected === selectedSegnalazione) {
        this.selected = null
      } else { this.selected = selectedSegnalazione }
    },

    checkurl () {
      const parametro = new URLSearchParams(window.location.search.substring(1))
      const verifica = parametro.get('segnalazione')
      console.log(verifica)
      if (verifica === 'linkinvalido') {
        this.invalid = true
        this.statoupdated = false
      }

      if (verifica === 'STATOAGGIORNATO') {
        this.caricaSegnalazioni(this.$store.getters.getComune.codiceCatasto).then(risultato => {
          console.log('listaggiornata')
          this.smista(risultato)
        })
        this.statoupdated = true
        this.overlay = false
        this.invalid = false
      }
    },

    goBack () {
      this.invalid = false
      this.statoupdated = false
      this.$router.push('/backoffice/' + this.codiceComune)
    },

    filtra (array, servizio, stato) {
      console.log('filtroSer ', servizio)
      console.log('filtroStato ', stato)
      var filtrato = []
      if (servizio !== null && servizio !== '' && servizio !== undefined) {
        console.log(servizio, 'not null')
        array.forEach(index => {
          // i dati che arrivano dal props sono ijn string
          if (index.viewServizio.id.toString() === servizio) {
            filtrato.push(index)
          }
        })
        this.segnalazioni = filtrato
      }

      if (stato !== null && stato !== '' && stato !== undefined) {
        console.log(stato, 'not null')
        if (this.segnalazioni === filtrato) {
          var secondofiltro = []
          filtrato.forEach(index => {
            if (index.stato === stato) {
              secondofiltro.push(index)
            }
          })
          this.segnalazioni = secondofiltro
        } else {
          this.segnalazioni.forEach(index => {
            if (index.stato === stato) {
              filtrato.push(index)
            }
          })
          this.segnalazioni = filtrato
        }
      }
    },

    smista (array) {
      var uno = []
      var due = []
      array.forEach(index => {
        if (index.stato !== 'RIFIUTATA' && index.stato !== 'ARCHIVIATA') {
          uno.push(index)
        } else {
          due.push(index)
        }
      })
      this.principale = uno
      this.archivio = due
      this.switch(this.$store.getters.backoffice)
      this.filtra(this.segnalazioni, this.filtri[0], this.filtri[1])
    },

    switch (apri) {
      console.log('aperto in nav ', apri)
      if (apri === 'Principale') {
        this.segnalazioni = this.archivio
      } else {
        this.segnalazioni = this.principale
      }
    }
  },

  mounted () {
    this.checkurl()
    console.log('MOUNT', this.codiceComune)
    if (!this.codiceComune) {
      this.caricaSegnalazioni(this.$store.getters.getComune.codiceCatasto).then(risultato => {
        this.smista(risultato)
        console.log(this.segnalazioni)
      })
    } else {
      this.caricaSegnalazioni(this.codiceComune).then(risultato => {
        this.smista(risultato)
        console.log(this.segnalazioni)
      })
    }
  },
  computed: {
    backoffice () { return this.$store.getters.backoffice }
  },
  watch: {
    codiceComune: function (NewComune, OldComune) {
      console.log('OLD -->', OldComune)
      console.log('NEW -->', NewComune)
      if (NewComune) {
        this.caricaSegnalazioni(NewComune).then(risultato => {
          this.smista(risultato)
          console.log(this.segnalazioni)
        })
      }
    },
    $route: function (NewUrl, OldUrl) {
      console.log('OLD -->', OldUrl)
      console.log('NEW -->', NewUrl)
      if (NewUrl) {
        this.checkurl()
      }
    },
    backoffice (newbch, oldbch) {
      console.log(oldbch, ' -->', newbch)
      if (newbch) {
        this.switch(newbch)
      }
    },
    filtri: function (ff) {
    // ff[0] è servizio
    // ff[1] è stato
      if (ff.Empty) { ff[0] = null }
      if (!ff[1]) { ff[1] = null }
      console.log('arrayfiltri -->', ff)
      if (ff[1] === 'RIFIUTATA' || ff[1] === 'ARCHIVIATA') {
        this.switch('Principale')
        this.filtra(this.segnalazioni, ff[0], ff[1])
      } else {
        this.switch('Archivio')
        this.filtra(this.segnalazioni, ff[0], ff[1])
      }
      console.log('filtrato per filtro', this.segnalazioni)
    }
  }
}
</script>
